/**
 * Toast queue — micro-feedback for copy/export/share/errors plus optional
 * Undo-style action buttons. Toasts auto-dismiss after `ms`; clicking the
 * action runs `onAction` and dismisses immediately.
 */

export interface ToastAction {
  label: string
  onAction: () => void
}

export interface ToastItem {
  id: number
  message: string
  action?: ToastAction
}

export interface ShowToastOptions {
  ms?: number
  action?: ToastAction
}

let nextId = 1
export const toasts = $state<ToastItem[]>([])

const DEFAULT_MS = 2400
const ACTION_MS = 6000

function remove(id: number): void {
  const idx = toasts.findIndex((t) => t.id === id)
  if (idx !== -1) toasts.splice(idx, 1)
}

export function showToast(message: string, options: ShowToastOptions = {}): number {
  const id = nextId++
  const item: ToastItem = { id, message }
  if (options.action) item.action = options.action
  toasts.push(item)
  const ms = options.ms ?? (options.action ? ACTION_MS : DEFAULT_MS)
  window.setTimeout(() => remove(id), ms)
  return id
}

export function dismissToast(id: number): void {
  remove(id)
}
